// Singleton QueryClient. См. docs/data-layer.md §9.

import { QueryClient } from '@tanstack/react-query'

import { getCacheSettings } from './query/cache'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Дефолт — тот же пресет `default`, что и у фабрик: одна точка правды на приложение.
      ...getCacheSettings('default'),
      retry: 1,
      // В Mini App окно теряет фокус постоянно — рефетчи на фокус только мешают.
      refetchOnWindowFocus: false,
      // `refetchOnMount` намеренно оставлен дефолтным (`true`): «перезапросить при входе на
      // экран» решается через `staleTime` конкретной ручки, а не глобальным выключателем.
    },
  },
})
